// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YLqS","right":"styles_right__162iR"};